const toCents = (amount: number) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  const regexGetOnlyNumbers = /[^\d-]/gim

  return +formatter.format(amount).replace(regexGetOnlyNumbers, '')
}

const toCurrencyFormat = (
  amount?: number,
  {
    currency = 'USD',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    emptySpace = false,
    isInCents = true,
  }: {
    currency?: string
    minimumFractionDigits?: number
    maximumFractionDigits?: number
    emptySpace?: boolean
    isInCents?: boolean
  } = {}
) => {
  if (amount === undefined) {
    return
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  })

  const value = isInCents ? amount / 100 : amount

  if (emptySpace) {
    const regexCurrencySignWithEmptySpaceBetweenValue = /(\D)(\d)/

    const formatted = formatter
      .format(value)
      .replace(regexCurrencySignWithEmptySpaceBetweenValue, '$1 $2')

    if (Number.isInteger(value)) {
      return formatted.replace('.00', '')
    }

    return formatted
  }

  if (Number.isInteger(value)) {
    return formatter.format(value).replace('.00', '')
  }

  return formatter.format(value)
}

const toDecimalFormat = (amount?: number) => {
  if (!amount) {
    return 0
  }

  return amount / 100
}

const toApiFormat = (amount?: number | null) => (amount ?? 0) * 100

const exports = {
  toCents,
  toCurrencyFormat,
  toDecimalFormat,
  toApiFormat,
}

export default exports
